import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import ShowIcon from '@interxfi/design-system/icons/react/icon-show';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import { DocgenPreviewMonthlyStatementDrawer } from '../../../../../../../../../../../features/generate/monthly-statement/docgen-preview-monthly-statement-drawer';
import { DocgenMonthlyStatementJobsTable } from '../../../../../../../../../../../features/generate/monthly-statement/job/docgen-monthly-statement-jobs-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsDocGenMonthlyStatement,
      label: 'Jobs',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsDocGenMonthlyStatement>,
  head: () => getPageHead('Monthly Statement Jobs'),
  component: DocgenMonthlyStatementJobList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <DocgenPreviewMonthlyStatementDrawer
              trigger={<Button affixIcon={<ShowIcon aria-hidden />} aria-label="Preview" size="small" variant="primary" />}
            />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsDocGenMonthlyStatement}
    />
  );
}

function DocgenMonthlyStatementJobList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <DocgenMonthlyStatementJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
